import { darkPalette } from '../palette'

export const MuiPaper = {
  styleOverrides: {
    root: {
      border: '1px solid #283d43',
      backgroundColor: '#002031',
      boxShadow:
        'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenuItem-root': {
        color: darkPalette?.text?.main,
        borderBottom: '1px solid #5C5C5C',
        padding: '10px 17px',
        '&:hover': {
          color: 'text.main',
        },
        '&:selected': {
          color: '#004744',
        },
        fontSize: 12,
        fontWeight: '500',
        '& .MuiSvgIcon-root': {
          fontSize: 18,
        },
        '&:last-child': {
          borderBottom: 'none',
        },
      },
      '& .MuiList-root': {
        paddingTop: '0px',
        paddingBottom: '0px',
      },
    },
  },
}
